import { fade, FadeProps } from "@remotion/transitions/fade";
import {
  getDefaultDurationInFrames,
  getDefaultPreviewClipDurationsInFrames,
  getDefaultTiming,
  ImageTransitionBuilder,
} from "./ImageTransitionBuilder.ts";
import { TransitionKind } from "@repo/api/transition";

const transitionKind = TransitionKind.enum.FADE;

export const ImageFadeTransitionBuilder: ImageTransitionBuilder<FadeProps> = {
  formConfig: {
    kind: transitionKind,
    buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
    speed: ["SLOW", "NORMAL", "FAST"],
  },

  transition: {
    getDurationInFrames: getDefaultDurationInFrames,
    buildPresentation: () => fade(),
    buildTiming: getDefaultTiming,
  },

  getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
};
